import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ConteneurDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-conteneur',
  templateUrl: './conteneur.component.html',
  styleUrls: ['./conteneur.component.css']
})
export class ConteneurComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.conteneurs$) conteneurs$: Observable<ConteneurDto[]>;

  private _conteneurId: number = null;
  Conteneurs: ConteneurDto[] = [];

  @Input()
  get conteneurId() {
    return this._conteneurId;
  }
  set conteneurId(val) {
    this._conteneurId = val;
    this.getConteneurInComponent();
  }

  ConteneurInComponent: string;

  c: Subscription;

  constructor() { }

  ngOnInit() {
    this.c = this.conteneurs$.subscribe(res => {
      if (res != null) {
        this.Conteneurs = res;
        this.getConteneurInComponent();
      }
    });
  }

  getConteneurInComponent() {
    let conteneur = this.Conteneurs.find(c => c.Id == this.conteneurId);
    this.ConteneurInComponent = (conteneur) ? conteneur.Identifiant : null;
  }

  ngOnDestroy() {
    this.c?.unsubscribe();
  }
}
